<mat-card class="individual-view">
    <div *ngIf="individual" class="row">
        <div class="col-md-6">
            <mat-card-title>{{ individual ? individual.first_name + ' ' + individual.last_name : '' }}
            </mat-card-title>
            <mat-card-subtitle>{{getIndividualType(individual)}}</mat-card-subtitle>
        </div>
        <div class="col-md-6 text-end" *ngIf="perm.canAddOrEditIndividualOrCompany()">
            <button (click)="editMode = !editMode" color="primary" mat-flat-button>
                {{editMode ? 'Details' : 'Edit' }}
            </button>
        </div>
    </div>
    <mat-card-content>
        <p class="mt-2">
            <button mat-stroked-button (click)="backToList()" class="me-2">
                <mat-icon>arrow_back</mat-icon> Back to list
            </button>
        </p>
        <div *ngIf="individual">
            <div *ngIf="!editMode">
                <mat-accordion class="example-headers-align">
                    <mat-expansion-panel [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Individual
                            </mat-panel-title>
                            <mat-panel-description>
                                {{individual.first_name + ' ' + individual.last_name}} <mat-icon>person</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="py-2 details">
                            <div class="my-2">
                                <table>

                                    <tr>
                                        <th>Phone number</th>
                                        <td>
                                            {{individual.phone_number ? individual.phone_number : '-'}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Alternative phone number</th>
                                        <td>
                                            {{individual.phone_number_alt ? individual.phone_number_alt : '-'}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Email</th>
                                        <td>
                                            {{individual.email ? individual.email : '-'}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Alternative email</th>
                                        <td>
                                            {{individual.email_alt ? individual.email_alt : '-'}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Date of birth</th>
                                        <td>
                                            {{formatDateOfBirth(individual)}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Number of dependants</th>
                                        <td>
                                            {{individual.dependant_number}}
                                        </td>
                                    </tr>

                                    <tr>
                                        <th>Created</th>
                                        <td>{{utilService.formatTime(individual.created_at)}}</td>
                                    </tr>

                                    <tr>
                                        <th>Updated</th>
                                        <td>{{utilService.formatTime(individual.updated_at)}}</td>
                                    </tr>

                                    <tr>
                                        <th>Sage</th>
                                        <td>
                                            <span *ngIf="isOnSage" class="text-success">
                                                <mat-icon class="align-middle me-1">check_circle</mat-icon>
                                                On Sage
                                                <span *ngIf="individual.sage_contact_id"> ({{ individual.sage_contact_id }})</span>
                                            </span>
                                            <span *ngIf="!isOnSage">
                                                Not on Sage
                                                <button *ngIf="!perm.isViewer()" mat-stroked-button color="primary" class="ms-2" (click)="addToSage()"
                                                    [disabled]="addingToSage">
                                                    <mat-icon>add</mat-icon>
                                                    {{ addingToSage ? 'Adding…' : 'Add to Sage' }}
                                                </button>
                                            </span>
                                        </td>
                                    </tr>

                                </table>
                                <div class="py-2 mt-4">
                                    <mat-divider></mat-divider>
                                </div>
                                <div *ngIf="address" class="my-2">
                                    <h3>Address</h3>
                                    <table>

                                        <tr>
                                            <th>Address</th>
                                            <td>{{address.address_1}}</td>
                                        </tr>

                                        <tr>
                                            <th>Alternative address</th>
                                            <td>{{address.address_2}}</td>
                                        </tr>

                                        <tr>
                                            <th>Building number</th>
                                            <td>{{address.building_apt_number}}</td>
                                        </tr>

                                        <tr>
                                            <th>Province</th>
                                            <td>{{address.province}}</td>
                                        </tr>

                                        <tr>
                                            <th>City</th>
                                            <td>{{address.city}}</td>
                                        </tr>

                                        <tr>
                                            <th>Postcode</th>
                                            <td>{{address.postcode}}</td>
                                        </tr>

                                        <tr>
                                            <th>Country</th>
                                            <td>{{address.country}}</td>
                                        </tr>

                                    </table>
                                </div>
                            </div>
                        </div>

                    </mat-expansion-panel>
                    <mat-expansion-panel *ngIf="company">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                Company
                            </mat-panel-title>
                            <mat-panel-description>
                                {{ company.name }} <mat-icon>business</mat-icon>
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="py-2 details">
                            <div class="my-2">
                                <table>
                                    <tr>
                                        <th>Name</th>
                                        <td>{{company.name}}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Email
                                        </th>
                                        <td>{{company.email}}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Alternative email
                                        </th>
                                        <td>{{company.email_alt}}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Phone number
                                        </th>
                                        <td>{{company.phone_number}}</td>
                                    </tr>
                                    <tr>
                                        <th>
                                            Alternative phone number
                                        </th>
                                        <td>{{company.phone_number_alt}}</td>
                                    </tr>

                                    <tr>
                                        <th>
                                            Practice number
                                        </th>
                                        <td>{{company.practice_number}}</td>
                                    </tr>

                                    <tr>
                                        <th>
                                            VAT registration number
                                        </th>
                                        <td>{{company.vat_registration_number}}</td>
                                    </tr>

                                    <tr>
                                        <th>
                                            Created
                                        </th>
                                        <td>{{formatTime(company.created_at)}}</td>
                                    </tr>

                                    <tr>
                                        <th>
                                            Updated
                                        </th>
                                        <td>{{formatTime(company.updated_at)}}</td>
                                    </tr>

                                    <tr>
                                        <th>
                                            Type
                                        </th>
                                        <td>{{getCompanyType(company)}}</td>
                                    </tr>
                                </table>

                                <div class="py-2">
                                    <mat-divider></mat-divider>
                                </div>

                                <div class="my-2">
                                    <h3>Address</h3>
                                    <table *ngIf="companyAddress">

                                        <tr>
                                            <th>Address</th>
                                            <td>{{companyAddress.address_1}}</td>
                                        </tr>

                                        <tr>
                                            <th>Alternative address</th>
                                            <td>{{companyAddress.address_2}}</td>
                                        </tr>

                                        <tr>
                                            <th>Building number</th>
                                            <td>{{companyAddress.building_apt_number}}</td>
                                        </tr>

                                        <tr>
                                            <th>Province</th>
                                            <td>{{companyAddress.province}}</td>
                                        </tr>

                                        <tr>
                                            <th>City</th>
                                            <td>{{companyAddress.city}}</td>
                                        </tr>

                                        <tr>
                                            <th>Postcode</th>
                                            <td>{{companyAddress.postcode}}</td>
                                        </tr>

                                        <tr>
                                            <th>Country</th>
                                            <td>{{companyAddress.country}}</td>
                                        </tr>

                                    </table>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </mat-accordion>
            </div>
        </div>
        <div *ngIf="editMode">
            <h3 mat-card-subtitle>Edit individual</h3>
            <form [formGroup]="individualDetailsForm">
                <div class="row">
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Title</mat-label>
                                <mat-select required data-testid="individual-title" formControlName="title">
                                    <mat-option value="Mr">Mr</mat-option>
                                    <mat-option value="Mrs">Mrs</mat-option>
                                    <mat-option value="Miss">Miss</mat-option>
                                    <mat-option value="Prof">Prof</mat-option>
                                    <mat-option value="Dr">Dr</mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('title')?.invalid">
                                    Choose from provided options
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Initials</mat-label>
                                <input required data-testid="individual-initials" formControlName="initials" matInput
                                    placeholder="Initials">
                                <mat-error *ngIf="individualDetailsForm.get('initials')?.invalid">
                                    Initials are required
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>First name</mat-label>
                                <input required data-testid="individual-first-name" formControlName="firstName" matInput
                                    placeholder="First name">
                                <mat-error *ngIf="individualDetailsForm.get('firstName')?.invalid">
                                    First name is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Last name</mat-label>
                                <input required data-testid="individual-last-name" formControlName="lastName" matInput
                                    placeholder="Surname">
                                <mat-error *ngIf="individualDetailsForm.get('lastName')?.invalid">
                                    Surname is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Gender</mat-label>
                                <mat-select required data-testid="individual-gender" formControlName="gender">
                                    <mat-option value="male">Male</mat-option>
                                    <mat-option value="female">Female</mat-option>
                                    <mat-option value="other">Other</mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('gender')?.invalid">
                                    Gender is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Is this an animal?</mat-label>
                                <mat-select required data-testid="individual-animal" formControlName="isAnimal">
                                    <mat-option value="0">No</mat-option>
                                    <mat-option value="1">Yes</mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('isAnimal')?.invalid">
                                    Invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Phone Number</mat-label>
                                <input required data-testid="individual-phone-number" formControlName="phoneNumber"
                                    matInput placeholder="Phone Number">
                                <mat-error *ngIf="individualDetailsForm.get('phoneNumber')?.invalid">
                                    Phone Number is required
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Alternative phone number</mat-label>
                                <input formControlName="phoneNumberAlt" matInput placeholder="Phone Number">
                                <mat-error *ngIf="individualDetailsForm.get('phoneNumberAlt')?.invalid">
                                    Alternative phone number is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Email address</mat-label>
                                <input required data-testid="individual-email" formControlName="email" matInput
                                    placeholder="Email address">
                                <mat-error *ngIf="individualDetailsForm.get('email')?.invalid">
                                    Email address is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Alternative email address</mat-label>
                                <input data-testid="individual-alt-email" formControlName="emailAlt" matInput
                                    placeholder="Email address">
                                <mat-error *ngIf="individualDetailsForm.get('emailAlt')?.invalid">
                                    Alternative email address is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Date of birth</mat-label>
                                <input required data-testid="individual-date-of-birth" formControlName="dateOfBirth"
                                    matInput [matDatepicker]="picker1">
                                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                <mat-datepicker #picker1></mat-datepicker>
                                <mat-error *ngIf="individualDetailsForm.get('date')?.invalid">
                                    Date of birth is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Number Of dependants</mat-label>
                                <input data-testid="individual-number-of-dependants" type="number" min="0"
                                    formControlName="numberOfDependants" matInput placeholder="Number of Dependants">
                                <mat-error *ngIf="individualDetailsForm.get('numberOfDependants')?.invalid">
                                    Number of dependants is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Individual type</mat-label>
                                <mat-select required data-testid="individual-type" #chosenValue
                                    formControlName="individualType">
                                    <mat-option *ngFor="let type of individualTypes" [value]="type.id">
                                        {{type.type}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('individualType')?.invalid">
                                    Choose from provided options
                                </mat-error>
                            </mat-form-field>
                        </p>

                     

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Company</mat-label>
                                <input 
                                  data-testid="company-name" 
                                  [disabled]="isLoading" 
                                  type="text"
                                  placeholder="Company name" 
                                  aria-label="Company" 
                                  matInput
                                  formControlName="companyName" 
                                  [matAutocomplete]="auto"
                                  [value]="selectedCompany?.name"
                                >
                                <mat-autocomplete 
                                  (optionSelected)="companySelected($event)" 
                                  autoActiveFirstOption
                                  #auto="matAutocomplete">
                                  <mat-option *ngFor="let company of companies" [value]="company">
                                    {{company.name}}
                                  </mat-option>
                                </mat-autocomplete>
                              </mat-form-field>
                              
                        </p>

                    </div>
                </div>
            </form>

            <div class="py-2">
                <mat-divider></mat-divider>
            </div>

            <h3 mat-card-subtitle>Individual company</h3>

            <div class="my-2">
                <button *ngIf="!selectedCompany" (click)="openSearchCompanyDialog()" mat-stroked-button>
                    Select company
                </button>
            </div>

            <div class="details my-2" *ngIf="selectedCompany">

                <button *ngIf="selectedCompany" (click)="deselectCompany()" mat-stroked-button>
                    <mat-icon>cancel</mat-icon> Remove
                </button>

                <table class="mt-4">
                    <tr>
                        <th>
                            Name
                        </th>
                        <td>
                            {{ selectedCompany.name ? selectedCompany.name : "-" }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            Alternative email address
                        </th>
                        <td>
                            {{
                            selectedCompany.email_alt ? selectedCompany.email_alt :
                            "-"
                            }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            Phone number
                        </th>
                        <td>
                            {{
                            selectedCompany.phone_number ?
                            selectedCompany.phone_number :"-"
                            }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            Email
                        </th>
                        <td>
                            {{ selectedCompany.email ? selectedCompany.email : "-"
                            }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            Alternative phone number
                        </th>
                        <td>
                            {{ selectedCompany.phone_number_alt ?
                            selectedCompany.phone_number_alt : "-" }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            Practice number
                        </th>
                        <td>
                            {{ selectedCompany.practice_number ?
                            selectedCompany.practice_number : "-" }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            VAT registration number
                        </th>
                        <td>
                            {{ selectedCompany.vat_registration_number ?
                            selectedCompany.vat_registration_number : "-" }}
                        </td>
                    </tr>

                </table>
            </div>

            <div class="py-2 mt-4">
                <mat-divider></mat-divider>
            </div>

            <h3 mat-card-subtitle>Edit address</h3>

            <form [formGroup]="addressDetailsForm">

                <div class="row">
                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Search for a country</mat-label>
                                <input required [disabled]="isLoading" type="text" placeholder="Search for a country"
                                    aria-label="Search for a country" matInput formControlName="country"
                                    [matAutocomplete]="autoCountry">
                                <mat-autocomplete autoActiveFirstOption #autoCountry="matAutocomplete">
                                    <mat-option *ngFor="let country of filteredCountriesForIndividual | async"
                                        [value]="country.name">
                                        {{country.name}}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-icon matPrefix>search</mat-icon>
                                <mat-error *ngIf="individualDetailsForm.get('country')?.invalid">
                                    Country is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Province</mat-label>
                                <mat-select required data-testid="individual-province" formControlName="province">
                                    <mat-option *ngFor="let province of provinces" value="{{province.name}}">
                                        {{province.name}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="individualDetailsForm.get('province')?.invalid">
                                    Province is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>City</mat-label>
                                <input type="text" formControlName="city" matInput />
                                <mat-error *ngIf="addressDetailsForm.get('city')?.invalid">
                                    City is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Address line 1</mat-label>
                                <input required data-testid="individual-address-line-1" formControlName="addressLine1"
                                    matInput placeholder="Address Line 1">
                                <mat-error *ngIf="individualDetailsForm.get('addressLine1')?.invalid">
                                    Address Line 1 is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>

                    <div class="col-md-6">

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Suburb</mat-label>
                                <input data-testid="individual-address-line-2" formControlName="addressLine2" matInput
                                    placeholder="Suburb">
                                <mat-error *ngIf="individualDetailsForm.get('addressLine2')?.invalid">
                                    Suburb is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Building Number</mat-label>
                                <input required data-testid="individual-building-apt-number"
                                    formControlName="buildingAptNumber" type="number" min="1" matInput
                                    placeholder="Building Number">
                                <mat-error *ngIf="individualDetailsForm.get('buildingAptNumber')?.invalid">
                                    Building Number is required
                                </mat-error>
                            </mat-form-field>
                        </p>

                        <p>
                            <mat-form-field appearance="outline">
                                <mat-label>Postcode</mat-label>
                                <input required data-testid="individual-postcode" formControlName="postcode" matInput
                                    placeholder="Postcode">
                                <mat-error *ngIf="individualDetailsForm.get('postcode')?.invalid">
                                    Postcode is invalid
                                </mat-error>
                            </mat-form-field>
                        </p>

                    </div>
                </div>
            </form>

            <div class="text-end mt-2">
                <button data-testid="next-step" (click)="save()"
                    [disabled]="!individualDetailsForm.valid || !addressDetailsForm.valid || isLoading" class="mx-1"
                    color="primary" mat-raised-button>
                    <mat-icon>save</mat-icon> Save
                </button>
            </div>

        </div>
    </mat-card-content>
</mat-card>